export const BaseDict = {
    DaysToDrop: "Days",
    HoursToDrop: "Hours",
    MinutesToDrop: "Mins",
    SecondsToDrop: "Secs",
    SomeoneWonJackpot: "Someone just won the Jackpot!",
    LearnMore: "Learn more",
    MustDropBefore: "Must drop before",
};
//# sourceMappingURL=dict.js.map